module.exports = __webpack_public_path__ + "static/image3_fr-cabdacc000c47727063ca386acf19010.png";